import { Base64 } from 'js-base64';

import request from '../untils/request';

export const adsListApi = params => {
  return request({
    url: '/operation/advertisement/index',
    params,
    authCode: 'ADV_INDEX',
  });
};

export const adsDelApi = params => {
  return request({
    url: '/operation/advertisement/delete',
    params,
    authCode: 'ADV_INDEX',
  });
};

export const adsPositionApi = params => {
  return request({
    url: '/operation/advertisement-position/adv-position-list',
    params,
    authCode: 'ADV-POSITION_INDEX',
  });
};

export const adsPositionListApi = params => {
  return request({
    url: '/operation/advertisement-position/index',
    params,
    authCode: 'ADV-POSITION_INDEX',
  });
};

export const adsPositionDelApi = params => {
  return request({
    url: '/operation/advertisement-position/delete',
    params,
    authCode: 'ADV-POSITION_EDIT',
  });
};

export const adsPositionOperateApi = params => {
  return request({
    url: '/operation/advertisement-position/operate',
    params,
    authCode: 'ADV-POSITION_EDIT',
  });
};

export const adsPositionSyncApi = params => {
  return request({
    url: '/operation/advertisement-position/sync',
    params,
    authCode: 'ADV-POSITION_EDIT',
  });
};

export const adsPositionLogApi = params => {
  return request({
    url: '/operation/advertisement-position/log',
    params,
    authCode: 'ADV-POSITION_EDIT',
  });
};

export const adsPositionDetailApi = params => {
  return request({
    url: '/operation/advertisement-position/detail',
    params,
    authCode: 'ADV-POSITION_EDIT',
  });
};

export const adsPositionEditApi = params => {
  return request({
    url: '/operation/advertisement-position/save',
    params,
    authCode: 'ADV-POSITION_EDIT',
  });
};

export const adsGoodsClassListApi = params => {
  return request({
    url: '/goods/goods-class/one-list',
    params,
    authCode: 'ADV-POSITION_EDIT',
  });
};

export const adsDetailApi = params => {
  return request({
    url: '/operation/advertisement/detail',
    params,
    authCode: 'ADVERTISEMENT_DETAIL',
  });
};

/**
 * 获取APP接口返回的HTML代码
 */
export const adsAppHtmlApi = content => {
  return request({
    url: '/operation/advertisement/get-hot-content',
    params: {
      method: 'post',
      content: Base64.encode(content), // base64 编码防止 waf 防火墙拦截
    },
    authCode: 'ADV_INDEX',
  });
};

export const adsEditSaveApi = params => {
  return request({
    url: '/operation/advertisement/save',
    params,
    authCode: 'ADV_EDIT',
  });
};

export const postersListApi = params => {
  return request({
    url: '/operation/poster/index',
    params,
    authCode: 'POSTER_INDEX',
  });
};

export const postersSortingApi = params => {
  return request({
    url: '/operation/poster/sort',
    params,
    authCode: 'POSTER_INDEX',
  });
};

export const postersDeleteApi = params => {
  return request({
    url: '/operation/poster/delete',
    params,
    authCode: 'POSTER_INDEX',
  });
};

export const postersEditCreateApi = params => {
  return request({
    url: '/operation/poster/save',
    params,
    authCode: 'POSTER_INDEX',
  });
};

export const postersClassApi = params => {
  return request({
    url: '/operation/poster/class-list',
    params,
    authCode: 'POSTER_INDEX',
  });
};

export const postersClassListApi = params => {
  return request({
    url: '/operation/poster/post-class',
    params,
    authCode: 'POSTER_INDEX',
  });
};

export const postersClassDeleteApi = params => {
  return request({
    url: '/operation/poster/class-delete',
    params,
    authCode: 'POSTER-CLASS_INDEX',
  });
};

export const postersClassEditApi = params => {
  return request({
    url: '/operation/poster/save-class',
    params,
    authCode: 'POSTER-CLASS_INDEX',
  });
};

export const giftListApi = params => {
  return request({
    url: '/operation/gift/index',
    params,
    authCode: 'OFFER-INDEX',
  });
};

export const couponListApi = params => {
  return request({
    url: '/operation/coupon/index',
    params,
    authCode: 'COUPON_INDEX',
  });
};

export const couponSendListApi = params => {
  return request({
    url: '/operation/coupon/send-list',
    params,
    authCode: 'COUPON_INDEX',
  });
};

export const couponAfterSaleListApi = params => {
  return request({
    url: '/operation/coupon/after-list',
    params,
    authCode: 'COUPON_INDEX',
  });
};

export const couponOperateApi = params => {
  return request({
    url: '/operation/coupon/operate',
    params,
    authCode: 'COUPON_INDEX',
  });
};

export const couponSendingApi = params => {
  return request({
    url: '/operation/coupon/send',
    params,
    authCode: 'COUPON_INDEX',
  });
};

export const couponCreateApi = params => {
  return request({
    url: '/operation/coupon/create',
    params,
    authCode: 'COUPON_INDEX',
  });
};

export const adsSkipListApi = params => {
  return request({
    url: '/operation/advertisement-jump/index',
    params,
    authCode: 'ADVERTISEMENT-JUMP_INDEX',
  });
};

export const adsSkipOperateApi = params => {
  return request({
    url: '/operation/advertisement-jump/operate',
    params,
  });
};

export const adsSkipSaveApi = params => {
  return request({
    url: '/operation/advertisement-jump/save',
    params,
  });
};

export const adsSkipSelectionListApi = params => {
  return request({
    url: '/operation/advertisement/jump-list',
    params,
  });
};

export const adsRefreshingApi = params => {
  return request({
    url: '/operation/advertisement/refresh',
    params,
  });
};

export const adsLogApi = params => {
  return request({
    url: '/operation/advertisement/log',
    params,
  });
};

export const adsPreviewApi = params => {
  return request({
    url: '/operation/advertisement/preview',
    params,
  });
};

export const giftActivityListApi = params => {
  return request({
    url: '/operation/offer/index',
    params,
    authCode: 'OFFER-INDEX',
  });
};

export const giftActivityLogsApi = params => {
  return request({
    url: '/operation/offer/logs',
    params,
  });
};

export const giftActivityDetailApi = params => {
  return request({
    url: '/operation/offer/detail',
    params,
  });
};

export const giftActivityDelApi = params => {
  return request({
    url: '/operation/offer/del',
    params,
  });
};

export const giftActivitySaveApi = params => {
  return request({
    url: '/operation/offer/save',
    params,
  });
};

export const giftActivityOperateApi = params => {
  return request({
    url: '/operation/offer/operate',
    params,
  });
};

export const exchangeListApi = params => {
  return request({
    url: '/operation/exchange/index',
    params,
    authCode: 'OFFER-INDEX',
  });
};

export const exchangeLogsApi = params => {
  return request({
    url: '/operation/exchange/logs',
    params,
  });
};

export const exchangeDetailApi = params => {
  return request({
    url: '/operation/exchange/detail',
    params,
  });
};

export const exchangeDelApi = params => {
  return request({
    url: '/operation/exchange/del',
    params,
  });
};

export const exchangeSaveApi = params => {
  return request({
    url: '/operation/exchange/save',
    params,
  });
};

export const exchangeOperateApi = params => {
  return request({
    url: '/operation/exchange/operate',
    params,
  });
};

export const exchangeSearchGoodsApi = params => {
  return request({
    url: '/operation/exchange/search-goods',
    params,
  });
};

export const exchangeGetConfigApi = params => {
  return request({
    url: '/operation/exchange/get-config',
    params,
  });
};

export const exchangeSetConfigApi = params => {
  return request({
    url: '/operation/exchange/set-config',
    params,
  });
};

export const skinsListApi = params => {
  return request({
    url: '/operation/skins/index',
    params,
  });
};

export const skinsDetailApi = params => {
  return request({
    url: '/operation/skins/detail',
    params,
  });
};

export const skinsSaveApi = params => {
  return request({
    url: '/operation/skins/save',
    params,
  });
};

export const skinsDelApi = params => {
  return request({
    url: '/operation/skins/delete',
    params,
  });
};

export const skinsOperateApi = params => {
  return request({
    url: '/operation/skins/operate',
    params,
  });
};

export const skinsGetGrayApi = params => {
  return request({
    url: '/operation/skins/get-gray',
    params,
  });
};

export const skinsSetGrayApi = params => {
  return request({
    url: '/operation/skins/set-gray',
    params,
  });
};

export const getDelayShipmentApi = params => {
  return request({
    url: '/operation/delay/get-detail',
    params,
  });
};

export const saveDelayShipmentApi = params => {
  return request({
    url: '/operation/delay/edit',
    params,
  });
};

export const operationDelayApi = params => {
  return request({
    url: '/operation/delay/index',
    params,
  });
};
export const operationDelDelayApi = params => {
  return request({
    url: '/operation/delay/delete',
    params,
  });
};
export const operationDelayStatusApi = params => {
  return request({
    url: '/operation/delay/set-status',
    params,
  });
};
